import React, { useState } from 'react';
import { TopBar } from '@/components/TopBar';
import { Page } from '@/components/Page';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle } from '@/components/ui/drawer';
import { Label } from '@/components/ui/label';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import api, { errMsg } from '@/lib/api';
import { toast } from 'sonner';
import { money } from '@/lib/helpers';
import { Search, Plus, User } from 'lucide-react';

export default function Customers() {
  const qc = useQueryClient();
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: '', phone: '' });
  const { data: customers = [] } = useQuery({ queryKey: ['customers', q], queryFn: async () => (await api.get('/customers', { params: { q } })).data.data });

  const add = async () => {
    if (!form.name && !form.phone) { toast.error('Enter a name or mobile.'); return; }
    try { await api.post('/customers', form); toast.success('Customer added'); setOpen(false); setForm({ name: '', phone: '' }); qc.invalidateQueries({ queryKey: ['customers'] }); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <Page>
      <TopBar title="Customers" showStore={false} right={<Button size="sm" className="h-9 rounded-full" onClick={() => setOpen(true)} data-testid="customer-add"><Plus className="h-4 w-4" /></Button>} />
      <div className="px-4 pt-4">
        <div className="relative"><Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name or mobile" className="h-11 rounded-xl pl-9" data-testid="customer-search" /></div>
        <div className="mt-3 space-y-2">
          {customers.length === 0 ? <p className="py-10 text-center text-sm text-muted-foreground">No customers yet.</p> :
            customers.map((c) => (
              <div key={c.id} className="flex items-center justify-between rounded-xl border border-border bg-card p-3" data-testid={`customer-${c.id}`}>
                <div className="flex items-center gap-3"><span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary"><User className="h-4 w-4" /></span>
                  <div><p className="text-sm font-medium">{c.name || '(no name)'}</p><p className="text-xs text-muted-foreground">{c.phone || '—'}</p></div></div>
                <div className="text-right"><p className="font-mono text-sm font-semibold">{money(c.total_purchases)}</p><p className="text-xs text-muted-foreground">{c.purchase_count} bills</p></div>
              </div>
            ))}
        </div>
      </div>
      <Drawer open={open} onOpenChange={setOpen}><DrawerContent className="bg-card"><div className="mx-auto my-2 h-1 w-10 rounded-full bg-border" /><DrawerHeader><DrawerTitle>Add customer</DrawerTitle></DrawerHeader>
        <div className="space-y-3 px-4 pb-6">
          <div><Label>Name</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1 h-11 rounded-xl" data-testid="customer-form-name" /></div>
          <div><Label>Mobile</Label><Input inputMode="numeric" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-1 h-11 rounded-xl" data-testid="customer-form-phone" /></div>
          <Button className="h-12 w-full rounded-xl" onClick={add} data-testid="customer-form-save">Save</Button>
        </div></DrawerContent></Drawer>
    </Page>
  );
}
